import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cn from 'classnames';
import { Badge } from '../Badge';
import styles from './StatusBadge.module.scss';
export const StatusBadge = /*#__PURE__*/ React.forwardRef(function StatusBadge(props, ref) {
    const { children, skin = 'default', className } = props, rest = _object_without_properties(props, [
        "children",
        "skin",
        "className"
    ]);
    return /*#__PURE__*/ _jsx(Badge, _object_spread_props(_object_spread({}, rest), {
        ref: ref,
        className: cn(styles.statusBadge, className),
        skin: skin,
        size: "small",
        rounded: true,
        outlined: true,
        children: children
    }));
});
